import * as m from 'mithril';
// import setTrackingEvents from '../../services/trackingService';
import './header.component.scss';

let currentRoute: string = '/home'; // default
let isMenuVisible: boolean = false;

function updateCurrentRoute(): void {
    const newRoute = m.route.get();
    if (newRoute) {
        currentRoute = newRoute;
    }
    // console.warn(`### route: ${currentRoute}`);
}

function toggleMenuVisibility() {
    isMenuVisible = !isMenuVisible;
}

const setNavLinks = () => {
    return ['Home', 'Music', 'Shows', 'Store', 'Contact'].map((nav) => {
        const link = `/${nav.toLowerCase()}`;
        /* @ts-ignore */
        const navLink = <m.route.Link
            href={link}
            onclick={() => { isMenuVisible = false; }}
        >{nav}</m.route.Link>;

        if (link === currentRoute) {
            return <span class="selected">{navLink}</span>;
        } else {
            /* @ts-ignore */
            return <span>{navLink}</span>;
        }
    });
};

export default function HeaderView() {
    return {
        // oncreate: () => setTrackingEvents('a.target-link'),
        view: () => (<>
            {updateCurrentRoute()}
            {currentRoute !== '/p' ? (
            <div class="top-app-bar">
                <div class="top-app-bar__row top-app-bar__row--top-nav">
                    <div class="top-app-bar__section top-app-bar__section--top-nav-wide">
                        {setNavLinks()}
                    </div>
                    <div class="top-app-bar__section top-app-bar__section--top-nav-narrow">
                        <button onclick={toggleMenuVisibility}>
                            <div class="button-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" stroke="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </div>
                            <div class="button-text">
                                Menu
                            </div>
                        </button>
                        {isMenuVisible ? (
                        <div class="menu">
                            {setNavLinks()}
                        </div>
                        ) : ('')}
                    </div>
                </div>
                <div class="top-app-bar__row top-app-bar__row--logo">
                    <div class="top-app-bar-logo">
                        <img src="/assets/vh-logo-v4.1200x382.webp" alt="Void Hunter logo" />
                    </div>
                </div>
            </div>
            ) : (
            <div class="top-app-bar promo-landing-header">
                <div class="top-app-bar__row top-app-bar__row--top-nav">
                    <div class="top-app-bar__section top-app-bar__section--top-nav-wide">
                        <div class="social-icons">
                            <a class="instagram-icon target-link" data-type="social" data-target="instagram" href="https://www.instagram.com/voidhunterofficial/" target="_blank">
                                <img src="/assets/ig-icon-white.png" alt="Instagram icon" />
                            </a>
                            <a class="facebook-icon target-link" data-type="social" data-target="facebook" href="https://www.facebook.com/voidhunterofficial/" target="_blank">
                                <img src="/assets/fb-icon-white.png" alt="Facebook icon" />
                            </a>
                        </div>
                        <div class="bandsintown-follow">
                            <iframe src="https://bandsintown.com/artist/id_15560541/track_button?actor_type=ARTIST&background_color=rgba(231,225,212,1)&hover_color=rgba(231,225,212,0.8)&font=Roboto&bitIcon=show&text=FOLLOW&text_color=rgba(0,0,0,1)&locale=en&display_tracker_count=hide&size=large"
                                title="newsletter-widget"
                                height="35"
                                width="150"
                                scrolling="no"
                                frameborder="0"
                                style="border:none; overflow:hidden;"
                                allowtransparency="true">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </>),
    };

}
